import gql from 'graphql-tag';

import { getSingleProp } from 'src/utils/lib/graphql';
import apolloClient from 'src/store/client';
import { BRIEF_DEBUG_DATA_VISIBLE } from 'src/lib/featureFlags';
import { FRAGMENT_MULTI_PROMPT_TEMPLATE } from '../schema';

const MUTATION = gql`
  mutation ReleaseExpertMultiPromptTemplate($id: ID!) {
    releaseExpertMultiPromptTemplate(id: $id) {
      ...CustomerMultiPromptTemplate
    }
  }
  ${FRAGMENT_MULTI_PROMPT_TEMPLATE}
`;

const prepareContext = (id) => {
  if (!BRIEF_DEBUG_DATA_VISIBLE) {
    return null;
  }

  const title = `"ReleaseExpertMultiPromptTemplate" request [templateId: ${id}]`;
  return { traceAuthorComplete: true, traceAuthorCompleteTitle: title };
};

export const releaseExpertMultiPromptTemplate = async ({ id }) => {
  const variables = {
    id,
  };

  const response = await apolloClient.mutate({
    mutation: MUTATION,
    variables,
    context: prepareContext(id),
  });
  return getSingleProp(response.data);
};
